import { createStore } from 'vuex'
import api from '../api'

export default createStore({
  state: {
    accounts: [],
    allAccounts: [],
    categories: {
      expenseMajor: [],
      expenseMinor: [],
      incomeMajor: [],
      incomeMinor: []
    },
    loading: false,
    // 用户认证相关状态
    token: localStorage.getItem('access_token') || null,
    user: JSON.parse(localStorage.getItem('user_info') || 'null'),
    isAuthenticated: !!localStorage.getItem('access_token')
  },
  mutations: {
    SET_LOADING (state, loading) {
      state.loading = loading
    },
    SET_ACCOUNTS (state, accounts) {
      state.accounts = accounts
    },
    SET_ALL_ACCOUNTS (state, accounts) {
      state.allAccounts = accounts
    },
    SET_CATEGORIES (state, { type, data }) {
      state.categories[type] = data
    },
    // 用户认证相关mutations
    SET_TOKEN (state, token) {
      state.token = token
      state.isAuthenticated = !!token
      if (token) {
        localStorage.setItem('access_token', token)
      } else {
        localStorage.removeItem('access_token')
      }
    },
    SET_USER (state, user) {
      state.user = user
      if (user) {
        localStorage.setItem('user_info', JSON.stringify(user))
      } else {
        localStorage.removeItem('user_info')
      }
    },
    LOGOUT (state) {
      state.token = null
      state.user = null
      state.isAuthenticated = false
      localStorage.removeItem('access_token')
      localStorage.removeItem('user_info')
    }
  },
  actions: {
    async fetchAccounts ({ commit }, { includeHidden = false } = {}) {
      try {
        commit('SET_LOADING', true)
        const response = await api.getAccounts({ include_hidden: includeHidden })
        // 后端账户API直接返回账户数组，不是包装在data字段中
        console.log('API返回的账户数据:', response)
        
        // 只保留激活状态的账户（is_active !== false）
        const activeAccounts = response.filter(account => account.is_active !== false)
        console.log('过滤后的激活账户:', activeAccounts)
        
        commit('SET_ACCOUNTS', activeAccounts)
        return activeAccounts
      } catch (error) {
        console.error('获取账户列表失败:', error)
        
        // 临时mock数据，确保页面能正常显示
        const mockAccounts = [
          { id: 1, account_name: '现金账户', account_type: '现金', is_active: true },
          { id: 2, account_name: '工商银行储蓄卡', account_type: '银行卡', is_active: true },
          { id: 3, account_name: '支付宝', account_type: '电子钱包', is_active: true },
          { id: 4, account_name: '招商银行信用卡', account_type: '银行卡', is_active: true }
          // 移除了 is_active: false 的投资账户
        ]
        console.log('使用临时mock账户数据:', mockAccounts)
        commit('SET_ACCOUNTS', mockAccounts)
        return mockAccounts
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async fetchExpenseMajorCategories ({ commit }) {
      try {
        const data = await api.getExpenseMajorCategories()
        commit('SET_CATEGORIES', { type: 'expenseMajor', data })
        return data
      } catch (error) {
        console.error('获取支出大类失败:', error)
        throw error
      }
    },
    async fetchExpenseMinorCategories ({ commit }, majorCategoryId) {
      try {
        const data = await api.getExpenseMinorCategories(majorCategoryId)
        commit('SET_CATEGORIES', { type: 'expenseMinor', data })
        return data
      } catch (error) {
        console.error('获取支出小类失败:', error)
        throw error
      }
    },
    async fetchIncomeMajorCategories ({ commit }) {
      try {
        const data = await api.getIncomeMajorCategories()
        commit('SET_CATEGORIES', { type: 'incomeMajor', data })
        return data
      } catch (error) {
        console.error('获取收入大类失败:', error)
        throw error
      }
    },
    async fetchIncomeMinorCategories ({ commit }, majorCategoryId) {
      try {
        const data = await api.getIncomeMinorCategories(majorCategoryId)
        commit('SET_CATEGORIES', { type: 'incomeMinor', data })
        return data
      } catch (error) {
        console.error('获取收入小类失败:', error)
        throw error
      }
    }
  },
  getters: {
    activeAccounts: state => {
      console.log('Store中的所有账户:', state.accounts)
      const activeAccounts = state.accounts.filter(account => account.is_active)
      console.log('过滤后的活跃账户:', activeAccounts)
      return activeAccounts
    },
    getAccountById: state => id => state.accounts.find(account => account.id === id)
  },
  modules: {
  }
}) 